import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddEmployeePage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'Employee',
    reasonField: false,
  };

  const VoucherFormDiscountTemplate = {
    disabled: false,
    discountType: 'percentage_marketing',
    showFreeAncillaries: true,
    excludeTypes: ['credit_amount', 'free_ride_hybrid', 'value_hybrid'],
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: false,
  };

  return (
    <>
      <VoucherFormBanner title='Employee, family and friends' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity />
            <VoucherFormStructure />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddEmployeePage;
